import React from "react";

const IconV1 = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
    <path d="M9 9L13 5L9 1" stroke="#FCFAFA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 5L1 5" stroke="#FCFAFA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconV2 = ({ className, ...props }) => (
  <svg className={className} height="9" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 7L10 4L7 1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 4L1 4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconV3 = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    {...props}
  >
    <path d="M9 9L13 5L9 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 5L1 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function IconArrowRight({ version = "v1", ...props }) {
  switch (version) {
    case "v2":
      return <IconV2 {...props} />;
    case "v3":
      return <IconV3 {...props} />;
    default:
      return <IconV1 {...props} />;
  }
}
